import z from 'zod'

export const tabItems = ['national', 'province', 'city'] as const

export const searchParamsSchema = z.object({
  tab: z
    .string()
    .optional()
    .default('national')
    .transform(val => {
      if (val === 'district') return 'city' as const
      if ((tabItems as readonly string[]).includes(val)) {
        return val as (typeof tabItems)[number]
      }
      return 'national' as const
    }),
  province_code: z.string().optional(),
  city_code: z.string().optional()
})

export type SearchParams = z.infer<typeof searchParamsSchema>

export type TabItem = (typeof tabItems)[number]
